import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");

const SupplierLedgerTable = ({
  printMode      = false,
  isCustomerTab  = false,
  customerList   = [],
  customerOpening = 0,
  customerClosing = 0,
}) => {
  const { list, loading, openingBalance, closingBalance } =
    useSelector((state) => state.supplierLedger);

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const displayList    = isCustomerTab ? customerList    : list;
  const displayOpening = isCustomerTab ? customerOpening : openingBalance;
  const displayClosing = isCustomerTab ? customerClosing : closingBalance;

  const totals = displayList.reduce(
    (acc, row) => {
      acc.debit  += Number(row.debit_amount  || 0);
      acc.credit += Number(row.credit_amount || 0);
      return acc;
    },
    { debit: 0, credit: 0 }
  );

  const columns = [
    { title: "No.", render: (_, __, i) => i + 1, width: 60 },
    {
      title: "Date",
      dataIndex: "created_date",
      width: 120,
      render: (date) => {
        if (!date) return "";
        const parsed = moment(date);
        return parsed.isValid() ? parsed.format("YYYY-MMM-DD") : "";
      },
    },
    {
      title: "Particular",
      dataIndex: "particular",
      width: 300,
      render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />,
    },
    { title: "VCH No",   dataIndex: "vch_no",   width: 120 },
    { title: "VCH Type", dataIndex: "vch_type",  width: 100 },
    {
      title: "Debit",
      dataIndex: "debit_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120,
    },
    {
      title: "Credit",
      dataIndex: "credit_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 120,
    },
  ];

  return (
    <Table
      rowKey={(row, i) => `${row.sequence}-${row.id}-${row.created_date}-${i}`}
      columns={columns}
      dataSource={displayList}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
        onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
      }}
      bordered
      scroll={printMode ? undefined : { x: "max-content" }}
      size={printMode ? "small" : "middle"}
      summary={() => (
        <>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5}><strong>Opening Balance</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              <strong>{format(parseFloat(displayOpening || 0).toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} align="right" />
            <Table.Summary.Cell index={7} align="right" />
          </Table.Summary.Row>

          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5}><strong>Grand Total</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              <strong>{format(totals.debit.toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} align="right">
              <strong>{format(totals.credit.toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={7} align="right" />
          </Table.Summary.Row>

          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5}><strong>Closing Balance</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              <strong>{format(parseFloat(displayClosing || 0).toFixed(2))}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} colSpan={2} align="right" />
          </Table.Summary.Row>
        </>
      )}
    />
  );
};

export default SupplierLedgerTable;